import React from 'react'
import MDXProvider from './MDXProvider'

export default ({ children }) => <MDXProvider>{children}</MDXProvider>
